import Image from "next/image";
import FaqSection from "./FaqSection";
import CompanyLogos from "../CompanyLogos";
import Review from "./Review";
import Footer from "../Footer";

const SeoComponent = ({revealForm}:{  revealForm: () => void}) => {
	return (
		<div>
			<section className='bg-white h-[90vh] flex items-center  dark:bg-gray-900 w-[95%] mx-auto'>
				<div className='grid max-w-screen-xl  px-4 py-8 mx-auto lg:gap-20 xl:gap-0 lg:py-16 lg:grid-cols-12'>
					<div className='mr-auto flex justify-center flex-col place-self-center lg:col-span-7 col-span-12'>
						<h1 className='max-w-2xl text-center md:text-left mb-6 text-4xl font-extrabold tracking-tight text-blue-900 leading-none md:text-5xl xl:text-6xl dark:text-white'>
							Craft a Tailored Cover Letter in Just 5 Seconds
						</h1>
						<p className='max-w-2xl mb-6 text-center md:text-left font-light text-gray-400 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400'>
							<span className='font-bold text-gray-600'>
								Bid farewell to the hassle of crafting a cover letter from the
								ground up.
							</span>
							<br />
							Utilizing cutting-edge GPT-4 technology, our AI-driven cover
							letter generator effortlessly produces a customized and
							ATS-friendly cover letter with just one click. Elevate yourself
							above the competition and secure more job interviews effortlessly.
						</p>
						<div className=' flex justify-center md:justify-start' onClick={()=>revealForm()}>
							<button className='active:scale-95 mt-2 inline-flex items-center  justify-center rounded-lg text-sm font-medium transition-color focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 disabled:opactiy-50 disabled:pointer-events-none bg-blue-500 text-white hover:bg-blue-600 w-full max-w-[300px] py-4 transition-colors'>
								<Image
									className='mr-2'
									width={24}
									height={24}
									alt='instant apply logo'
									src='/assets/images/lighting.png'
								/>
								Generate Instant Cover Letter
							</button>
						</div>
					</div>
					<div className='p-6 md:rotate-12   w-[380px] mt-10 md:w-[500px] h-[260px] md:h-[360px]  md:ml-10  rounded-lg border bordey-gray-100 shadow-lg '>
						<div className='  lg:mt-0 w-full h-full relative lg:col-span-5 lg:flex'>
							<Image
								src='/assets/images/resume.jpg'
								className='absolute rounded-lg '
								alt='brandlogo'
								loading='lazy'
								fill={true}
							/>
						</div>
					</div>
				</div>
			</section>
			<div className='overflow-hidden mb-20'>
				<CompanyLogos />
			</div>

			<section className='bg-white dark:bg-gray-900'>
				<div className='gap-8 items-center py-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6'>
					<div className='w-full max-w-[500px] h-[260px] md:h-[360px] lg:ml-6   rounded-lg '>
						<div className='  lg:mt-0 w-full h-full relative lg:col-span-5 lg:flex'>
							<Image
								src='/assets/images/gesture.jpg'
								className='absolute  object-contain'
								alt='brandlogo'
								loading='lazy'
								fill={true}
							/>
						</div>
					</div>

					<div className='mt-4 md:mt-0'>
						<h2 className='mb-4 text-4xl tracking-tight font-extrabold  text-blue-900 dark:text-white'>
							Craft Persuasive Cover Letters Effortlessly
						</h2>
						<p className='mb-6 font-light text-gray-500 md:text-lg dark:text-gray-400'>
							Our cover letter generation tool empowers you to create compelling
							cover letters with ease. Say goodbye to writer&apos;s block and
							hello to personalized, impactful messages that captivate
							recruiters. Whether you&apos;re a seasoned professional or just
							starting your career journey, our intuitive platform streamlines
							the process, allowing you to focus on what matters most – landing
							your dream job.
						</p>
					</div>
				</div>
			</section>

			<section className='bg-white dark:bg-gray-900'>
				<div className='gap-8 items-center py-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6'>
					<div className='mt-4 md:mt-0'>
						<h2 className='mb-4 text-4xl tracking-tight font-extrabold  text-blue-900 dark:text-white'>
							Unlock Your Career Potential
						</h2>
						<p className='mb-6 font-light text-gray-500 md:text-lg dark:text-gray-400'>
							Our cover letter generation tool is your gateway to a world of
							career opportunities. With its intuitive interface and expert
							guidance, you can effortlessly craft tailored cover letters that
							resonate with employers. Whether you&apos;re exploring new
							horizons or seeking advancement in your field, our tool empowers
							you to showcase your skills and experience with confidence.
						</p>
					</div>

					<div className='w-full max-w-[500px] h-[260px] md:h-[360px] lg:ml-6   rounded-lg '>
						<div className='lg:mt-0 w-full h-full relative lg:col-span-5 lg:flex'>
							<Image
								src='/assets/images/serious.jpg'
								className='absolute object-contain'
								alt='brandlogo'
								loading='lazy'
								fill={true}
							/>
						</div>
					</div>
				</div>
			</section>

			<section className='bg-white dark:bg-gray-900'>
				<div className='gap-8 items-center py-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6'>
					<div className='w-full max-w-[500px] h-[260px] md:h-[360px] lg:ml-6   rounded-lg '>
						<div className='  lg:mt-0 w-full h-full relative lg:col-span-5 lg:flex'>
							<Image
								src='/assets/images/gesture.jpg'
								className='absolute  object-contain'
								alt='brandlogo'
								loading='lazy'
								fill={true}
							/>
						</div>
					</div>

					<div className='mt-4 md:mt-0'>
						<h2 className='mb-4 text-4xl tracking-tight font-extrabold  text-blue-900 dark:text-white'>
							Streamline Your Job Application Process
						</h2>
						<p className='mb-6 font-light text-gray-500 md:text-lg dark:text-gray-400'>
							Tired of the tedious task of writing cover letters? Our cover
							letter generation tool simplifies the process, allowing you to
							create professional, tailored cover letters in minutes. Say
							goodbye to endless revisions and hello to a streamlined job
							application process. Focus your energy on finding the perfect job
							while our tool takes care of the rest.
						</p>
					</div>
				</div>
			</section>

			<section className='bg-blue-500 mt-20 my-5'>
				<div className='py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16'>
					<h1 className='mb-4 text-4xl font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl'>
						Empowering Your Career Journey
					</h1>
					<p className='mb-8 text-lg font-normal text-white lg:text-xl sm:px-16 lg:px-48 dark:text-gray-400'>
						At our platform, we are dedicated to nurturing individuals potential
						and fostering career advancement. We focus on creating opportunities
						where talent, ambition, and resources intersect, empowering
						individuals to achieve their professional aspirations.
					</p>
					<div className='flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0' onClick={()=>revealForm()}>
						<div
							className='inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-dark rounded-lg bg-white hover:scale-[1.1] transition focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900'
						>
							Generate Cover Letter
							<svg
								className='w-3.5 h-3.5 ms-2 rtl:rotate-180'
								aria-hidden='true'
								xmlns='http://www.w3.org/2000/svg'
								fill='none'
								viewBox='0 0 14 10'
							>
								<path
									stroke='currentColor'
									stroke-linecap='round'
									stroke-linejoin='round'
									stroke-width='2'
									d='M1 5h12m0 0L9 1m4 4L9 9'
								/>
							</svg>
						</div>
					</div>
				</div>
			</section>

			<section className='bg-white my-10 dark:bg-gray-900'>
				<div className='grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-20 lg:py-16 lg:grid-cols-12'>
					<div className='mr-auto place-self-center lg:col-span-5'>
						<h1 className='max-w-xl hidden  md:block mb-4 text-4xl text-blue-500 font-extrabold tracking-tight leading-none md:text-3xl xl:text-6xl dark:text-white'>
							Frequently Asked Questions
						</h1>
					</div>
					<div className='lg:mt-0 lg:col-span-7 lg:flex'>
						<FaqSection />
					</div>
				</div>
			</section>

			<div className='w-full p-5 mb-0 bg-gray-50'>
				<h1 className='my-2   text-blue-900 ml-20 text-4xl text-dark-700 font-bold  md:text-3xl xl:text-4xl dark:text-white'>
					Reviews
				</h1>
				<Review />
			</div>

			<Footer />
		</div>
	);
};

export default SeoComponent;
